<div class="container">
  <div class="row justify-content-center align-items-center mt-4">
    <form class="col-12">
      <div class="form-group">

        <div class="row" *ngIf="!showPinned">
          <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
            <p class="text-sm text-muted" *ngIf="capturedLinksToBind && capturedLinks">
              Showing {{ capturedLinksToBind.length }} of
              {{ capturedLinks.length }} Bookmarks
            </p>
          </div>

        </div>
        <div class="row" *ngIf="showPinned">
          <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
            <p class="text-sm text-muted">
              <small class="float-left ml-2">Showing
                {{+capturedLinks.length}} of {{+capturedLinks.length}}</small>
              <!-- <small *ngIf="displayItems && displayUnlinkedItems && items && unlinkedItems && showUnlinked"
                class="float-left ml-2">Showing {{+displayItems.length + +displayUnlinkedItems.length}} of
                {{+items.length + +unlinkedItems.length}}</small>
              <small *ngIf="displayItems && items && !showUnlinked" class="float-left ml-2">Showing
                {{+items.length}} of {{+items.length}}</small> -->
            </p>
          </div>
          <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">

            <a class="float-right text-sm text-primary" *ngIf="!showUnlinked"
              (click)="showAllBookmarks();showUnlinked=true">Show All</a>
            <a class="float-right text-sm text-primary" *ngIf="showUnlinked && displayUnlinkedItems"
              (click)="showPinnedBookmarks();showUnlinked=false">Show Pinned</a>
          </div>
        </div>
        <hr class="mt-0" />
        <mat-progress-bar mode="indeterminate" style="margin-top: -2rem;" *ngIf="isLoading"></mat-progress-bar>
        <div class="row">
          <div class="col">
            <label class="float-label" *ngIf="!isLoading && capturedLinksToBind && capturedLinksToBind.length == 0">No
              bookmarks found.</label>
          </div>
        </div>

        <div class="row" *ngIf="capturedLinksToBind && capturedLinksToBind.length != 0">
          <div class="col">
            <div class="row">
              <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">
                <div class="input-group mb-3">
                  <!-- Search form -->
                  <form class="navbar-search navbar-search-light form-inline mr-sm-3" id="navbar-search-links">
                    <div class="form-group mb-0" [ngClass]="{ focused: focus === true }">
                      <div class="input-group input-group-alternative input-group-merge">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-search"></i></span>
                        </div>
                        <input class="form-control" name="search" [(ngModel)]="linkSearchTerm" (keyup)="filterLinks()"
                          placeholder="Search" type="text" (focus)="focus = true" (blur)="focus = false" />
                      </div>
                    </div>
                    <button type="button" class="close" (click)="closeLinkSearch()" data-action="search-close"
                      data-target="#navbar-search-links" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12">

                <a class="float-right text-sm text-red" style="padding: 0.625rem 1.25rem;" (click)="deleteLinks()"
                  *ngIf="getIfSelected()">Delete Selected</a>
                <a class="float-right text-sm" style="padding: 0.625rem 1.25rem;" (click)="selectAllLinks()">Select
                  All</a>
                <div class="btn-group float-right" dropdown>
                  <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                    aria-controls="dropdown-basic">
                    Showing {{ currentBookmarkType | titlecase }}
                    <span class="caret"></span>
                  </button>
                  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                    aria-labelledby="button-basic">
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('link', 'links')">Pages</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('image', 'images')">Images</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('video', 'videos')">Videos</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('audio', 'audios')">Audio</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('selection', 'Notes')">Notes</a>
                    </li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('document', 'documents')">Documents</a>
                    </li>
                    <li class="divider dropdown-divider"></li>
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="showLinksOfType('all', 'all')">Show All</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col viewer">
            <div class="card-columns" [style.column-count]="columnsCount">
              <div class="card" *ngFor="let note of capturedLinksToBind" style="margin-bottom: 0.5rem; margin-top: 0.5rem;">
                <a style="width: 100%;">
                  <div class="card-tools">
                    <span style="display:inline">
                      <a (click)="deleteCapturedLink(note)" class="float-right"
                        style="margin-top: -0.1rem; vertical-align: super;">
                        <span class="btn-inner--icon"><i class="fa fa-trash text-red"></i></span>
                      </a>
                    </span>
                    <span class="custom-control custom-checkbox" style="display: inline;">
                      <input type="checkbox" class="custom-control-input" [attr.id]="note.id" type="checkbox"
                        [(ngModel)]="note.checked" name="chk" (change)="linkSelectChanged(note)" />
                      <label class="custom-control-label" [attr.for]="note.id"></label>
                    </span>
                    <span style="display:inline" *ngIf="note.lastUpdate">
                      {{ note.lastUpdate | dateAgo }}
                    </span>

                  </div>
                  <img class="card-img-main" alt="Image placeholder" [src]="note.src" *ngIf="note.type === 'image'" />
                  <img class="card-img-main" alt="Image placeholder" [src]="note.snapshot.ogImage.url" *ngIf="
                      note.type !== 'image' &&
                      note.snapshot &&
                        note.snapshot.ogImage &&
                        note.snapshot.ogImage.url &&
                      !(note.siteData && note.siteData.lead_image_url)
                    " />
                  <img class="card-img-main" alt="Image placeholder" [src]="note.siteData.lead_image_url" *ngIf="
                      note.type !== 'image' &&
                      note.siteData && note.siteData.lead_image_url
                    " />
                </a>
                <div class="card-header" style="height: 100px;">
                  <div class="row align-items-center">
                    <div class="col-1">
                      <i class="fas fa-bookmark" *ngIf="
                          note.type == 'link' ||
                          note.type == 'page' ||
                          !note.type
                        "></i>
                      <i class="fas fa-sticky-note" *ngIf="note.type == 'selection'"></i>
                      <i class="fas fa-images" *ngIf="note.type == 'image'"></i>
                      <i class="fas fa-video" *ngIf="note.type == 'video'"></i>
                      <i class="fas fa-volume-up" *ngIf="note.type == 'audio'"></i>
                    </div>
                    <div class="col-10">
                      <h5 class="mb-0 h5 card-title" *ngIf="note.title" style="font-weight: 400;">
                        <a (click)="showBookmark(note)">
                          {{
                            note.title.length > 90
                              ? (note.title | slice: 0:90) + ".."
                              : note.title
                          }}</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="card-body card-text" style="height: 110px; overflow: hidden;" *ngIf="note.selectionText">
                  <p *ngIf="note.selectionText" [innerHtml]="
                      note.selectionText.length > 100
                        ? (note.selectionText | slice: 0:100) + '..'
                        : note.selectionText
                    "></p>
                </div>
                <div class="card-body card-text" style="height: 200px; overflow: hidden;"
                  *ngIf="note.srcUrl && note.type == 'video'">
                  <video width="300" controls>
                    <source src="{{ note.srcUrl }}" type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                </div>
                <div class="card-body card-text" style="height: 100px; overflow: hidden;"
                  *ngIf="note.srcUrl && note.type == 'audio'">
                  <audio width="300" id="”AudioSong”" [src]="note.srcUrl" controls></audio>
                </div>
                <div class="card-footer text-sm">

                  <!-- <span style="vertical-align: sub;">Last updated {{ note.type }}</span> -->
                  <!-- <small style="vertical-align: sub;" class="text-muted">Last updated {{ note.lastUpdate | dateAgo }}</small> -->
                  <!-- <div class="row">

                    <div class="col">
                      <span style="vertical-align: sub;" *ngIf="note.lastUpdate">{{ note.lastUpdate | dateAgo }}</span>
                    </div>


                  </div> -->
                  <div class="row">
                    <div class="col-6">

                      <span style="display: inline;" >
                        <a (click)="openContentModal(note)" 
                          *ngIf="!note.fetchingContent && (note.type != 'audio' && note.type != 'video' && note.type != 'document')"
                          class="" style="vertical-align: super;">
                          <span class="btn-inner--icon"><i class="far fa-eye"></i> </span>
                        </a>
                        <span style="display: inline;" *ngIf="note.fetchingContent">
                          <mat-spinner diameter="20"></mat-spinner>
                        </span>
                        <a (click)="showPage(note)"
                          *ngIf="isProjectPage && !note.fetchingContent && (note.type != 'audio' && note.type != 'video' && note.type != 'document')"
                          class="" style="vertical-align: super;margin-left:4px;">
                          <span class="btn-inner--icon"><i class="fas fa-glasses"></i> </span>
                        </a>
                        <a (click)="pinLinkToNote(note)"
                          *ngIf="isProjectPage && !note.fetchingContent && (note.type != 'audio' && note.type != 'video' && note.type != 'document')"
                          class="" style="vertical-align: super;margin-left:4px;">
                          <span class="btn-inner--icon"><i class="fas fa-thumbtack"></i> </span>
                        </a>

                      </span>
                    </div>
                    <div class="col-6">
                      <a [href]="note.url" target="_blank" class="float-right"
                        style="vertical-align: super; padding-left: 1rem;">
                        <span class="btn-inner--icon"><i class="fas fa-external-link-alt"></i> </span></a>

                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Modal -->


<!-- Page viewer Overlay -->
<div bsModal #contentModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">

  <div class="modal-dialog modal-lg" style="max-width: 100vw !important;width: 100vw !important; ">
    <div class="modal-content" style="overflow-y: scroll;">
      <div class="modal-header">
        <!-- <h4 id="dialog-sizes-name1" class="modal-title pull-left">Large modal</h4> -->
        <button type="button" class="close pull-right" (click)="contentModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container h-100">

          <p [innerHtml]="contentToView"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Page Viewer Overlay -->